import React, { useEffect, useState } from "react";
import { PartyPopper, Loader2, Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import api from "@/lib/api";

export default function TeamCelebrationsToggle() {
  const [enabled, setEnabled] = useState(null);
  const [adminOn, setAdminOn] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/coach/team-preferences").then(({ data }) => setEnabled(data.celebrations_enabled)).catch(() => {});
    api.get("/feature-flags").then(({ data }) => setAdminOn(!!data.animations)).catch(() => {});
  }, []);

  const toggle = async (val) => {
    const prev = enabled;
    setEnabled(val);
    setSaving(true);
    try {
      const { data } = await api.put("/coach/team-preferences", { celebrations_enabled: val });
      setEnabled(data.celebrations_enabled);
      toast.success(`Team celebrations ${val ? "enabled" : "disabled"}`);
    } catch {
      setEnabled(prev);
      toast.error("Could not update setting");
    } finally {
      setSaving(false);
    }
  };

  if (enabled === null) return null;

  return (
    <Card className="mb-5 border-slate-200 p-4 shadow-sm" data-testid="team-celebrations-toggle">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-pink-100 text-pink-600">
          <PartyPopper className="h-4 w-4" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-slate-800">Team celebrations</p>
          <p className="text-xs text-slate-500">
            Confetti and star pop-ups when your team members earn lettering, hit merit milestones, or get a congrats Rally Call.
          </p>
          {!adminOn && (
            <p className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-amber-600" data-testid="team-celebrations-admin-off">
              <Lock className="h-3 w-3" /> Coming Soon: an optional fun feature for managing your team
            </p>
          )}
        </div>
        {saving && <Loader2 className="h-4 w-4 animate-spin text-slate-400" />}
        <Switch
          checked={enabled !== false}
          disabled={!adminOn || saving}
          onCheckedChange={toggle}
          data-testid="team-celebrations-switch"
        />
      </div>
    </Card>
  );
}
